import { defineNuxtPlugin } from '#app/nuxt'
import { LazyCookiesToast, LazyLogo, LazyPrimeCheckbox, LazyPrimeDatePicker, LazyPrimeFloatLabel, LazyPrimeIconField, LazyPrimeInputGroup, LazyPrimeInputGroupAddon, LazyPrimeInputText, LazyPrimePassword, LazyPrimeRadioButton, LazyPrimeSelect, LazyPrimeTextarea, LazyPrimeToggleSwitch, LazyPrimeButton, LazyPrimeSplitButton, LazyPrimeAccordion, LazyPrimeAccordionPanel, LazyPrimeAccordionHeader, LazyPrimeAccordionContent, LazyPrimeDivider, LazyPrimeStepper, LazyPrimeStepList, LazyPrimeStep, LazyPrimeStepPanel, LazyPrimeToolbar, LazyPrimeConfirmDialog, LazyPrimeDialog, LazyPrimeDrawer, LazyPrimeMenu, LazyPrimeMessage, LazyPrimeToast, LazyPrimeCarousel, LazyPrimeImage, LazyPrimeBadge, LazyPrimeProgressSpinner, LazyPrimeTag, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["CookiesToast", LazyCookiesToast],
["Logo", LazyLogo],
["PrimeCheckbox", LazyPrimeCheckbox],
["PrimeDatePicker", LazyPrimeDatePicker],
["PrimeFloatLabel", LazyPrimeFloatLabel],
["PrimeIconField", LazyPrimeIconField],
["PrimeInputGroup", LazyPrimeInputGroup],
["PrimeInputGroupAddon", LazyPrimeInputGroupAddon],
["PrimeInputText", LazyPrimeInputText],
["PrimePassword", LazyPrimePassword],
["PrimeRadioButton", LazyPrimeRadioButton],
["PrimeSelect", LazyPrimeSelect],
["PrimeTextarea", LazyPrimeTextarea],
["PrimeToggleSwitch", LazyPrimeToggleSwitch],
["PrimeButton", LazyPrimeButton],
["PrimeSplitButton", LazyPrimeSplitButton],
["PrimeAccordion", LazyPrimeAccordion],
["PrimeAccordionPanel", LazyPrimeAccordionPanel],
["PrimeAccordionHeader", LazyPrimeAccordionHeader],
["PrimeAccordionContent", LazyPrimeAccordionContent],
["PrimeDivider", LazyPrimeDivider],
["PrimeStepper", LazyPrimeStepper],
["PrimeStepList", LazyPrimeStepList],
["PrimeStep", LazyPrimeStep],
["PrimeStepPanel", LazyPrimeStepPanel],
["PrimeToolbar", LazyPrimeToolbar],
["PrimeConfirmDialog", LazyPrimeConfirmDialog],
["PrimeDialog", LazyPrimeDialog],
["PrimeDrawer", LazyPrimeDrawer],
["PrimeMenu", LazyPrimeMenu],
["PrimeMessage", LazyPrimeMessage],
["PrimeToast", LazyPrimeToast],
["PrimeCarousel", LazyPrimeCarousel],
["PrimeImage", LazyPrimeImage],
["PrimeBadge", LazyPrimeBadge],
["PrimeProgressSpinner", LazyPrimeProgressSpinner],
["PrimeTag", LazyPrimeTag],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
